// removed by extract-text-webpack-plugin
module.exports = {"app":"_2noTc","scrollable":"_1sH-E"};


//////////////////
// WEBPACK FOOTER
// ./app/components/app/app.scss
// module id = 455
// module chunks = 3 4 5 6 7